<template>
  <div>
    <HTTPresponse :alert="httpalert" @changeHTTPBoxState="HTTPState"></HTTPresponse>
    <v-card v-if="survey">
      <v-row wrap class="mb-5">
        <!-- Header Title && Firm -->
        <v-col cols="12" md="5">
          <h1
            class="mb-4"
            v-html="survey.info[`title_${$i18n.locale}`]"
          ></h1>
          <template v-if="firm">
            <IDLessCard
              :title="firm.title"
              :address="firm.address"
              :city="firm ? firm.city : null"
              :zip="firm ? firm.zip : null"
            ></IDLessCard>
          </template>
          <template v-else><IDLessCard></IDLessCard></template>
        </v-col>
        <!-- Survey score -->
        <v-col cols="12" md="7">
          <SurveyHeaderScore :survey="survey"></SurveyHeaderScore>
        </v-col>

      </v-row>

      <AllVue
        v-if="gridiews === 'all'"
        :survey="survey"
        :firm="firm"
        @reloadSubmitBtn="refreshSubmitBtn"
        @updateSeq="rerenderSeq"
        @changeGridViews="changeGrid"></AllVue>
      <SimpleVue
        v-else
        :survey="survey"
        :firm="firm"
        :createdBreadcrumbs="createdBreadcrumbs"
        :createdTab="createdTab"
        @reloadSubmitBtn="refreshSubmitBtn"
        @changeGridViews="changeGrid"></SimpleVue>
    </v-card>

    <QuestionBlock questionType="all" :keywords="$route.params.sequenceid"></QuestionBlock>
  </div>
</template>

<script>
import { showSequence } from '@/js/survey/showSequence'
import { getFirm } from '@/js/firm/getFirm'
import IDLessCard from '@/components/firm/IDLessCard'
import SurveyHeaderScore from '@/components/audits/SurveyHeaderScore'
import SimpleVue from '@/components/audits/survey/grid-views/SimpleVue'
import AllVue from '@/components/audits/survey/grid-views/AllVue'
import QuestionBlock from '@/components/questions/QuestionBlock'
import HTTPresponse from '@/components/app/HTTPresponse'

export default {
  components: {
    IDLessCard: IDLessCard,
    SurveyHeaderScore: SurveyHeaderScore,
    SimpleVue: SimpleVue,
    AllVue: AllVue,
    QuestionBlock: QuestionBlock,
    HTTPresponse: HTTPresponse
  },

  data () {
    return {
      survey: null,
      firm: null,
      createdBreadcrumbs: {
        sequence: null,
        question: null
      },
      createdTab: null,
      gridiews: this.$route.params.gridviews ? this.$route.params.gridviews : 'all',

      httpalert: false
    }
  },

  async created () {
    // if (!this.$store.getters['auth/isAuthenticated']) return
    await this.loadSeq()
    // const params = {
    //   answerid: this.$route.params.answerid,
    //   path: '',
    //   sequenceid: this.$route.params.sequenceid,
    //   key: this.$store.state.auth.token
    // }
    // showSequence(params)
    //   .then(response => {
    //     this.survey = response
    //     this.createdTab = {
    //       type: this.$route.params.type && this.$route.params.type === 'question' ? 'question' : 'sequence',
    //       object: this.$route.params.tab ? this.$route.params.tab : response.sequences[0]
    //     }
    //     this.createdBreadcrumbs.sequence = this.$route.params.type === 'question' ? response.sequences[0] : this.$route.params.tab ? this.$route.params.tab : response.sequences[0]
    //   })
    //   .catch(() => {
    //     this.httpalert = true
    //     setTimeout(() => {
    //       this.httpalert = false
    //     }, 4000)
    //   })

    getFirm(this.$store.state.auth.token)
      .then(response => {
        response.forEach(firm => {
          if (firm.id === this.$route.params.firmid) {
            this.firm = firm
            // return
          }
        })
      })
      .catch(() => {
        this.httpalert = true
        setTimeout(() => {
          this.httpalert = false
        }, 4000)
      })
  },

  methods: {
    loadSeq () {
      // console.log('test')
      // if (!this.$store.getters['auth/isAuthenticated']) return

      const params = {
        answerid: this.$route.params.answerid,
        path: '',
        sequenceid: this.$route.params.sequenceid,
        key: this.$store.state.auth.token
      }
      showSequence(params)
        .then(response => {
          this.survey = response
          this.createdTab = {
            type: this.$route.params.type && this.$route.params.type === 'question' ? 'question' : 'sequence',
            object: this.$route.params.tab ? this.$route.params.tab : response.sequences[0]
          }
          this.createdBreadcrumbs.sequence = this.$route.params.type === 'question' ? response.sequences[0] : this.$route.params.tab ? this.$route.params.tab : response.sequences[0]
        })
        .catch(() => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })
    },

    changeGrid () {
      if (this.gridiews === 'simple') this.gridiews = 'all'
      else if (this.gridiews === 'all') this.gridiews = 'simple'
      else this.gridiews = 'simple'
    },

    rerenderSeq () {
      this.loadSeq()
    },

    HTTPState (value) {
      this.httpalert = this.value
    },

    refreshSubmitBtn () { this.loadSeq() }
  }
}
</script>
